<template>
  <div v-if="show" class="container p8">
    <div>
      <!-- <div class="flex around align-center wrap column">
        <div v-if="enableQty" class="flex xs-font align-center column">
          <label><code>Quantity</code></label>
          <div class="flex center"><i class="fas fa-lg fa-arrow-down r8" @click="qty > 0 ? qty-- : null"></i><input class="sm-input qty-input r8" type="number" v-model.number="qty"><i class="fas fa-lg fa-arrow-up" @click="qty++"></i></div>
        </div>
      </div> -->
      <div
        class="p4 flexy"
        v-if="
          item.purchases.auction &&
          +new Date(item.purchases['auction end']) > Date.now()
        "
      >
        <div class="flex between b16 auction wrap">
          <h2>Auction</h2>
          <div class="sm-font align-end flex column">
            <span
              >High Bid: <b class="lg-font">${{ highbid[0] }}</b></span
            >
            <div>
              Ending <b><itime :timestamp="item.purchases['auction end']" /></b>
            </div>
            <span
              >Time left:
              <b>
                {{
                  timeremaining.toString().length > 9
                    ? Math.round(timeremaining / 1000 / 60 / 60 / 24 / 7) +
                      " weeks"
                    : timeremaining.toString().length > 8
                    ? Math.round(timeremaining / 1000 / 60 / 60 / 24) + " days"
                    : timeremaining.toString().length > 7
                    ? Math.round(timeremaining / 1000 / 60 / 60) + " hours"
                    : timeremaining.toString().length > 6
                    ? Math.round(timeremaining / 1000 / 60) + " minutes"
                    : Math.round(timeremaining / 1000) + " seconds"
                }} </b
              >| Bids: <b>{{ highbid[2] }}</b></span
            >
          </div>
        </div>
        <div class="container success p4 b16" v-if="highbid[1] == userhash">
          <b class="b16 t16"
            >You are the highest bidder.</b
          >
          <div class="container p8">
            <div class="">
              <div class="warn-text b8">
                Careful! Since you are the highest bidder, only submit a higher
                bid if you really mean to.
              </div>
              <label
                :for="`${item.type}_${item.id}_highbidoverride`"
                class="flex align-center sm-font"
              >
                <input
                  type="checkbox"
                  v-model="highbidoverride"
                  :id="`${item.type}_${item.id}_highbidoverride`"
                />Confirm you wish to increase your bid.
              </label>
            </div>
          </div>
        </div>
        <div>
          <div>
            <i
              v-if="item.purchases.currency"
              :class="`r4 fas fa-${
                item.purchases.currency.toLowerCase() === 'usd'
                  ? 'dollar-sign'
                  : ''
              }`"
            ></i>
            <input
              @click="
                bidamount = +highbid[0] + 1 || +item.purchases['minimum bid']
              "
              :min="highbid ? +highbid[0] + 1 : +item.purchases['minimum bid']"
              class="md-input b4"
              type="number"
              v-model="bidamount"
              placeholder="Bid"
            />
            {{
              "( min bid $" +
              (+highbid[0] + 1 || +item.purchases["minimum bid"]) +
              " )"
            }}
          </div>
          <button
            @click="
              show = false;
              !item.bids ? (item.bids = {}) : null;
              $store
                .dispatch('util', { type: 'hash', body: $store.state.auth.uid })
                .then((h) => {
                  $set(item.bids, bidamount, h);
                  $store
                    .dispatch('update', {
                      id: item.id,
                      type: item.type,
                      data: item,
                    })
                    .then(() => {
                      $store.state.user[$store.state.auth.uid].auctions =
                        $store.state.user[$store.state.auth.uid].auctions || {};
                      $store.state.user[$store.state.auth.uid].auctions[item.type+'_'+item.id] = bidamount
                      $store
                        .dispatch('update', {
                          type: 'user',
                          id: $store.state.auth.uid,
                          data: $store.state.user[$store.state.auth.uid],
                        })
                        .then(() =>
                          $set(
                            $store.state.counts,
                            'buy',
                            $store.state.counts.buy + 1 || 2
                          )
                        );
                    });
                  show = true;
                });
            "
            :disabled="
              !bidamount || (highbid[1] == userhash && !highbidoverride)
            "
            class="flex fill wrap align-center update xl-font p16 box-glow b16"
          >
            Commit Bid
          </button>
        </div>
      </div>
      <div
        v-if="!item.purchases.auction || (item.purchases['buy now'] && !item.purchases['auction complete'])"
        class="p4 flexy"
      >
        <div class="flex align-center between">
          <h2>Purchase</h2>
          <span class="flex align-center r8">
            <i
              v-if="item.purchases.currency"
              :class="`r4 fas fa-${
                item.purchases.currency.toLowerCase() === 'usd'
                  ? 'dollar-sign'
                  : ''
              }`"
            ></i>
            <b
              v-if="item.purchases.cost && !item.purchases.nameprice"
              class="xl-font"
              >{{
                (item.purchases.cost
                  ? qty * item.purchases.cost
                  : "Enter an amount") +
                (item.purchases["shipping and handling"] || 0)
              }}</b
            >
            <b v-else class="p4">
              <input
                class=""
                type="tel"
                v-model="customAmount"
                placeholder="Enter Amount"
              />
            </b>
          </span>
          <div
            class="xs-font flex column"
            v-if="item.purchases['shipping and handling']"
          >
            <b class="xs-font r4"
              ><i
                v-if="item.purchases.cost || customAmount"
                :class="`r4 fa-xs fas fa-${
                  item.purchases.currency.toLowerCase() === 'usd'
                    ? 'dollar-sign'
                    : ''
                }`"
              ></i
              >{{ item.purchases.cost || customAmount || "" }}</b
            >
            <div v-if="item.purchases['shipping and handling'] > 0">
              + {{ item.purchases["shipping and handling"] }} S&H
            </div>
          </div>
        </div>
        <button
          v-if="
            !item.purchases.auction ||
            (item.purchases.auction && item.purchases['buy now'])
          "
          :disabled="!item.purchases.cost && !customAmount"
          class="fill flex wrap align-center success xl-font p16 box-glow"
          type="button"
          @click="
            $store.state.auth.uid
              ? addToCart(item, qty)
              : $set(
                  $store.state.show,
                  'auth',
                  true
                )
          "
        >
          <i class="fas fa-shopping-cart r8"></i
          >{{ $store.state.auth.uid ? "Add to Cart" : "Log in to buy" }}
        </button>
      </div>
      <div v-else>
        <div class=" success-text p4 b16" v-if="highbid[1] == userhash && +new Date(item.purchases['auction end']).getTime() <= +new Date().getTime()">
          Congratulations, you won this auction. Check order details in 
              <router-link class="border-bottom indicate-text" :to="{path: '/profile', query: {section: 'money', tab: 'auctions'}}"> 
                Profile  > <i class="r4 far fa-money-bill-alt"></i>Money > <i class="r4 fa fa-gavel"></i>Auctions</router-link>
        </div>
        <p v-else-if="+new Date(item.purchases['auction end']).getTime() > +new Date().getTime()">Item unattainable</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buy",
  props: { item: { type: [Object, Array] } },
  computed: {
    highbid() {
      if (!this.item.purchases.auction) return false;
      else {
        let bidarray =
          this.item.bids &&
          Object.entries(this.item.bids)
            .map((x) => +x[0])
            .sort(function (a, b) {
              return b - a;
            });
        return this.item.bids
          ? [bidarray[0], this.item.bids[bidarray[0] + ""], bidarray.length]
          : this.item.purchases["minimum bid"];
      }
    },
    timeremaining() {
      return (
        this.item.purchases &&
        this.item.purchases.auction &&
        +new Date(this.item.purchases["auction end"]).getTime() >=
          +Date.now() &&
        +new Date(this.item.purchases["auction end"]).getTime() - +Date.now()
      );
    },
  },
  data() {
    return {
      customAmount: "",
      bidamount: "",
      enableQty: false,
      qty: 1,
      showError: false,
      userhash: "",
      highbidoverride: false, // to confirm a higher bid if already high-bidder
      show: false,
    };
  },
  methods: {
    async getuserhash() {
      return await this.$store
        .dispatch("util", { type: "hash", body: this.$store.state.auth.uid })
        .then((h) => this.$set(this, "userhash", h));
    },
    addToCart(item, qty) {
      if (!item.purchases.cost) {
        item.purchases.cost = this.customAmount;
      }
      // if user is logged in,
      if (this.$store.state.user[this.$store.state.auth.uid]) {
        // and does not have a cart already,

        if (!this.$store.state.user[this.$store.state.auth.uid].cart) {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid],
            "cart",
            {
              [item.id]: [
                item.type,
                item.id,
                item.purchases,
                qty,
                item.user,
                item.basics.title,
              ],
            }
          );

          // or does have items in the cart
        } else if (
          this.$store.state.user[this.$store.state.auth.uid].cart[item.id]
        ) {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid].cart,
            item.id,
            [
              item.type,
              item.id,
              item.purchases,
              this.$store.state.user[this.$store.state.auth.uid].cart[
                item.id
              ][3] + qty,
              item.user,
              item.basics.title,
            ]
          );

          // else user has cart but not this item
        } else {
          this.$set(
            this.$store.state.user[this.$store.state.auth.uid].cart,
            item.id,
            [
              item.type,
              item.id,
              item.purchases,
              qty,
              item.user,
              item.basics.title,
            ]
          );
        }
        delete this.$store.state.user[this.$store.state.auth.uid].user; // remove this.user stragler
        this.$store.state.user[this.$store.state.auth.uid].type = "user";

        // save updated user data
        var saveObj = {
          type: "user",
          id: this.$store.state.auth.uid,
          // noReload: true,
          data: this.$store.state.user[this.$store.state.auth.uid],
        };
        this.$store.dispatch("update", saveObj).then(() => {
          // cheat to update the cart
          this.$set(this.$store.state.show, "cart", false);
          setTimeout(() => {
            this.$set(this.$store.state.show, "cart", true);
          }, 0);
        });
      } else {
        this.$store.state.anon.cart = JSON.parse(
          window.localStorage.getItem("cart")
        )
          ? JSON.parse(window.localStorage.getItem("cart"))
          : null;
        !this.$store.state.anon.cart
          ? this.$set(this.$store.state.anon, "cart", {
              [item.id]: {
                [Date.now()]: [
                  item.type,
                  item.id,
                  item.purchases,
                  qty,
                  item.user,
                  item.basics.title,
                ],
              },
            })
          : !this.$store.state.anon.cart[item.id]
          ? this.$set(this.$store.state.anon.cart, item.id, {
              [Date.now()]: [
                item.type,
                item.id,
                item.purchases,
                qty,
                item.user,
                item.basics.title,
              ],
            })
          : this.$set(this.$store.state.anon.cart[item.id], Date.now(), [
              item.type,
              item.id,
              item.purchases,
              qty,
              item.user,
              item.basics.title,
            ]);
        localStorage.setItem(
          "cart",
          JSON.stringify(this.$store.state.anon.cart)
        );
        this.$set(this.$store.state.show, "cart", false);
        setTimeout(() => {
          this.$set(this.$store.state.show, "cart", true);
        }, 0);
      }
    },
  },
  mounted() {
    this.getuserhash();
    this.show = true;
  },
  watch: {
    customAmount: function (val, oldVal) {
      console.log(val, oldVal);
      this.customAmount = val.replace(/\D/g, "");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
